const Footer = () => (
  <footer>
    <p>© 2026 EcoCharge. Smart solar prediction and neighborhood energy exchange.</p>
  </footer>
);

export default Footer;
